require.config( {
    paths: {
        'colorFeedTemplate': 'responsive-game-feed/app/scripts/templates',
        "moment": "moment/moment",
        'text': 'requirejs-text/text'
    },
    // packages: [{
    //     name : "GameDayCore",
    //     location : "responsive-gameday-core/src/js"
    // }]  
});

               
define('responsive-game-feed/app/GameFeed',['require','exports','module','../app/scripts/models/Feed','../app/scripts/views/Error','../app/scripts/views/Feed','../app/scripts/utils/Utils','./scripts/utils/logger','../app/scripts/utils/DeviceDetection','bam.url/url','gameday-device-interaction/gameday-device-interaction'],function(require, exports, module) {
    'use strict';

    var FeedModel = require("../app/scripts/models/Feed");
    var ErrorView = require("../app/scripts/views/Error");
    var FeedView = require("../app/scripts/views/Feed");
    var Utils = require("../app/scripts/utils/Utils");
    var logg = require( "./scripts/utils/logger");
    var DeviceDetection = require('../app/scripts/utils/DeviceDetection');
    var Url = require("bam.url/url");
    var DeviceInteracton = require("gameday-device-interaction/gameday-device-interaction");
    var firstLoad = true;
   


    /**
     * An App module which acts as a controller -- tying together models and views,
     * handling routing, and providing a default set of options to pass along
     * to the models.
     */

    var GameFeed = {
    
        /**
         * The default options
         */
        options: {
            gid: '2014_03_19_pitmlb_bosmlb_1',
            gpk: '',
            interval: 5000,
            retryLimit: 10,
            liveMode: true,
            debugMode: false,
            property: 'mlb',
            templatePath: "../templates/",
            tracking: "omniture",
            videoInline : true,
            language : null,
            full: true,
            link : true,
            deviceType : null
        },
        
        events: {
           "EVENT_RENDER_SUCCESS" : "renderSuccess"
        },
        
        retryCount: 1,

        /**
         * Initialize the App module by extending the default options (if passed),
         * creating the relevant models and views, setting routes, and providing
         * functionality to execute when routes are triggered.
         *
         * @param {Object} options An object which can override the default set of
         * options
         */

        init: function(options) {

            // Extend default options
            options = $.extend(true, {}, this.options, options);
            if(options.debugMode){
                logg.setLevel('log');
            }
            Utils.options = options;
            


            // Initialize feed model
            var feedModel = new FeedModel(options);
            this.feedModel = feedModel;

            var that = this;
            var device = new DeviceDetection();



            //Initialize views
            var feedView = new FeedView();
            var errorView = new ErrorView();
            this.errorView = errorView;


            
            /**
             * Hide any errors that may have been displayed and show the loading
             * indicator.
             */
            function preRender() {      
                // Hide error

                errorView.render().hide();
                Utils.options.deviceInteraction = DeviceInteracton.create(options.deviceType);
                Utils.options.language = Utils.getLanguage();
                Utils.options.sharingEnable = (options.deviceType === "iphone" || options.deviceType === "ipad") ? false : true;
                $("#game-feed").addClass(Utils.options.language);                
                if (Utils.options.deviceType) {
                  $("body").addClass(Utils.options.deviceType)
                } 
                
            }


            /**
             * Load the default default feeds
             */
            function renderDefaultFeeds() {

                // Bind success and error callbacks
                $(feedView).bind(feedView.events["EVENT_RENDER_SUCCESS"], function(r) {
                    $(that).trigger(that.events["EVENT_RENDER_SUCCESS"]);
                });
                
               
                
                $(feedModel).bind(feedModel.events["EVENT_LOAD_SUCCESS"], function(e, responses) {
                    var data = feedModel.getNewEntries(responses.data.items);              
                    feedModel.onTimeFetch(10000);
                    errorView.hide();
                    
                    

                }).bind(feedModel.events["EVENT_LOAD_ERROR"], function(e) {
                    errorView.show(); 
                    feedModel.onTimeFetch(30000);
                }).bind(feedModel.events["EVENT_DATA_PARSED_SUCCESS"], function(e, data) {                    
                    feedView.render(data, true);
                })



                var scrollCheck = function() {
                    if ($(window).scrollTop() + $(window).height() == $(document).height()) {
                        //load full file
                        feedModel.config.full = true;
                        feedModel.stop();
                        feedModel.start();
                        feedModel.fetch();
                    }
                }

                feedModel.start();
                feedModel.fetch();

            }

            // Request the default feeds;
            preRender();
            renderDefaultFeeds();

        },
        
        destroy: function() {
           if(this.feedModel) {
              this.feedModel.stop();
           }
        },
        
        loadFullList: function() {
            //load full file
            this.feedModel.config.full = true;
            this.feedModel.stop();
            this.feedModel.fetch();
            this.feedModel.start();
            this.errorView.destory();
        }

    }

    return GameFeed;

});

